import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const  route = new Router({
  mode: "history", // require service support
  // !!注意: 二级路由不需要加 '/'
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: () => import("../views/home/index"),
    },
    {
      path: "/shoes",
      name: "shoes",
      component: () => import("../views/home/shoes"),
    },
    {
      path: "/printer",
      name: "printer",
      meta: {
        title: '悦璐乐打印机专营店'
      },
      component: () => import("../views/home/printer")
    },
    // 日本客户服务店
    {
      path: "/couture",
      name: "couture",
      component: () => import("../views/home/couture")
    }
  ]
});

route.beforeEach((to, from, next) => {
  console.log(to);
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


export default route
